/* ============
 * All MessageTemplateTypes
 * ============
 *
 * All message template types.
 */

import Vue from 'vue';
import store from './../../store';
import messageTemplateTypeTransformer from './../../transformers/messageTemplateType';

const success = ({ data }, resolve) => {
  const messageTemplateTypes = messageTemplateTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllMessageTemplateTypes', messageTemplateTypes);
  resolve(messageTemplateTypes);
};

const failed = (error, reject) => reject(error);

// Display message template types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('message_template_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/messageTemplateType/all.js